export default __webpack_public_path__ + "static/media/webTraderIcon3.775819c4.webp";